<script lang="ts">
    import type {ICuota, IPagoCard} from "../../../interfaces";
    import NauiCheckbox from "../../../naui/atoms/NauiCheckbox.svelte";
    import NauiState from "../../../naui/atoms/NauiState.svelte";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";
    import {getFormatter} from "../../../utils";
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();
    const formatter = getFormatter();

    export let data: IPagoCard;
    export let reciboUrl: string;
    export let filtered: Array<string> = null;

    let cuotasFiltered;
    let displayCuotaWarning = {};

    $: {
        cuotasFiltered = data ? data.cuotas : [];
        if (filtered) {
            console.log('Filtered', filtered);
            cuotasFiltered = data.cuotas.filter(c => filtered.some(id => id === c.recibo));
        }
    }
    let visibleRows = 3;
    let hitMore = false;

    function show() {
        visibleRows = data.cuotas.length;
        hitMore = true;
    }

    export function refresh() {
        data = data;
    }

    function getReciboUrl(cuota: ICuota) {
        return reciboUrl ? `${reciboUrl}${cuota.recibo}` : '#';
    }

    function checkCuotas(cuota: ICuota, index: number) {
        displayCuotaWarning[index] = data.cuotas.some(c => !c.selected && +c.numero < +cuota.numero);
    }

    function clearWarning(index: number) {
        displayCuotaWarning[index] = false;
    }
</script>
<section>
    <div class="box-l sx-1 mt-iii mb-ii pl-ii">
        <NauiCheckbox bind:value={data.selected} on:change={() => {dispatch('selected', {type: 'endoso', data})}}/>
        <p style="font-size: .9rem">Usted tiene <strong> {data.pending} cuotas pendientes</strong> asociadas a
            esta
            póliza y endoso. seleccione
            las cuotas a pagar</p>
    </div>
    <div class="m:hidden">
        <div class="gRow gHeader">
            <div></div>
            <div>No. cuota</div>
            <div>Fecha límite de pago</div>
            <div>Estado</div>
<!--            <div>Recibo para bancos</div>-->
            <div>Valor</div>
        </div>
    </div>
    <div class="hidden m:block">
        <hr>
    </div>
    {#each cuotasFiltered as cuota, index (cuota.numero)}
        {#if index < visibleRows}
            <div class="gRow relative" on:mouseleave={() => {clearWarning(index)}}>
                {#if displayCuotaWarning[index]}
                <div class="absolute" style="z-index: 200;  width: 85%; background-color: white; padding: 12px; border-radius: 4px; border: 2px solid #FF8E27;">
                    Seleccione los saldos a pagar en orden de vencimiento del más antiguo hacia adelante.
                </div>
                {/if}
                <div class="checkbox pl-ii" on:mouseenter={() => {checkCuotas(cuota, index)}}>
                    <NauiCheckbox bind:value={cuota.selected} on:change={dispatch('selected', {type: 'cuota', data: cuota, parent: data})}/>
                </div>
                <div class="cuota relative">
                    {cuota.numero}
                </div>
                <div class="fecha">
                    <div class="naui-date"
                         class:highlighted={cuota.estado.code === 3 || cuota.estado.code === 4}>{cuota.fechaLimite}</div>
                </div>
                <div class="estado">
                    <div>
                        <NauiState code="{cuota.estado.code}" label="{cuota.estado.label}"/>
                    </div>
                </div>
                <!--<div class="box recibo">
                    {#if cuota.estado.code < 4 && cuota.valor > 0}
                        <NauiButton icon="request_quote" iconStyle="outlined" color="accent" href={getReciboUrl(cuota)} target="_blank"/>
                    {:else if cuota.estado.code === 4}
                        <div class="tooltip">
                            <span class="tooltip-text alert">No es posible imprimir el recibo de pago porque la fecha de pago se encuentra vencida.
                                Lo invitamos a realizar el pago a través de este medio de forma electrónica.</span>
                            <NauiButton icon="warning_amber" iconStyle="outlined" color="accent" alt=""/>
                        </div>
                    {/if}
                </div>-->
                <div class="valor"><strong>{formatter(cuota.valor)}</strong></div>
            </div>
        {/if}
    {/each}
    {#if !hitMore && cuotasFiltered.length > 3}
        <div style="font-size: .9rem" class="pointer p-ii text-c" on:click={show}>
            <div class="box sx-i">
            <span class="secondary">
            Ver más cuotas</span> <span style="font-size: 1rem" class="material-icons secondary">expand_more</span>
            </div>
        </div>
    {/if}
</section>
<style>
    .alert {
        background: #FFF7EA;
        border: 1px solid #FF8E27;
        color: #FF8E27;
        font-size: 15px;
    }

    .alert > * {
        color: #FF8E27;
    }

    .naui-table tr th {
        background: #f4f5f6;
    }

    .naui-table .naui-date {
        border: none;
    }

    .naui-table tr th div {
        min-height: 24px;
        color: #5c5c5c;
        font-weight: 500;
    }

    .gRow {
        display: grid;
        grid-gap: 0 .5rem;
        grid-template-columns: 37px 75px 160px 1fr 150px 110px;
        border-bottom: 1px solid var(--border-color);
    }

    .gRow > div {
        display: flex;
        align-items: center;
        font-size: .9rem;
        padding-top: .5rem;
        padding-bottom: .5rem;
    }

    .gRow .naui-date {
        border: none;
    }

    .gRow .naui-date.highlighted {
        background: rgba(235, 104, 32, 0.16);
    }

    .gHeader {
        border: none;
        background: var(--back-gray);
    }

    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltip-text {
        visibility: hidden;
        width: 320px;
        padding: 5px;
        border-radius: 6px;

        top: 3rem;
        position: absolute;
        z-index: 1;
    }

    .tooltip:hover .tooltip-text {
        visibility: visible;
    }

    @media (max-width: 1024px) {
        .gRow {
            grid-gap: 0;
        }

        .gRow > div {
            display: block;
            border-bottom: 1px solid rgba(120, 120, 120, 0.1);
        }

        .gRow > div:before {
            font-size: 80%;
            display: block;
            color: var(--text-gray);
            margin-bottom: .25rem;
        }

        .gRow .checkbox {
            grid-area: checkbox;
        }

        .gRow .cuota {
            grid-area: cuota;
        }

        .gRow .fecha {
            grid-area: fecha;
        }

        .gRow .fecha .naui-date {
            width: max-content;
            background: #f4f4f4;
        }

        .gRow .fecha .naui-date.highlighted {
            background: rgba(235, 104, 32, 0.16);
        }

        .gRow .fecha:before {
            content: 'Fecha límite de pago'
        }

        .gRow .cuota:before {
            content: 'No. Cuota';
        }

        .gRow .estado {
            grid-area: estado;
        }

        .gRow .estado > div {
            padding: 0;
            position: relative;
            top: -4px;
            left: -7px;
        }

        .gRow .estado:before {
            content: 'Estado'
        }

        .gRow .recibo {
            grid-area: recibo;
        }

        .gRow .recibo:before {
            content: 'Recibo de pago'
        }

        .gRow .valor {
            grid-area: valor;
        }

        .gRow .valor:before {
            content: 'Valor'
        }

        .gRow {
            grid-template-columns: 40px calc(50% - 20px) calc(50% - 20px);
            grid-template-areas: 'checkbox cuota valor''checkbox fecha estado''checkbox recibo recibo';
            grid-template-rows: auto auto auto;
            margin-bottom: .5rem;
        }

    }


</style>